import React from 'react';
import {COUNTRIES, STATE_LABELS, statesForCountry} from '../constants/address';

const emptyAddress = () => ({ typeIds: [], line1: '', line2: '', line3: '', city: '', state: '', zip: '', country: 'US' });

export default function AddressForm({ addresses = [], addressTypes = [], onChange }) {
  const add = () => onChange([...addresses, emptyAddress()]);
  const remove = (i) => onChange(addresses.filter((_, idx) => idx !== i));
  const update = (i, field, value) => {
    const updated = addresses.map((a, idx) => {
      if (idx !== i) return a;
      const next = { ...a, [field]: value };
      if (field === 'country') next.state = '';
      return next;
    });
    onChange(updated);
  };

  const toggleType = (i, typeId) => {
    const current = addresses[i].typeIds || [];
    const next = current.includes(typeId) ? current.filter(id => id !== typeId) : [...current, typeId];
    update(i, 'typeIds', next);
  };

  const input = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-inset focus:ring-indigo-600";
  const select = "w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-1 focus:ring-inset focus:ring-indigo-600";

  return (
    <div className="space-y-3">
      {addresses.map((a, i) => (
        <div key={i} className="p-3 border border-gray-200 rounded-lg space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex flex-wrap gap-3">
              {addressTypes.map(t => (
                <label key={t.id} className="flex items-center gap-1 text-sm text-gray-700">
                  <input type="checkbox" checked={(a.typeIds || []).includes(t.id)} onChange={() => toggleType(i, t.id)}
                    className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" />
                  {t.name}
                </label>
              ))}
            </div>
            <button type="button" onClick={() => remove(i)} className="text-gray-400 hover:text-red-600 px-2">&times;</button>
          </div>
          <input type="text" placeholder="Street 1" value={a.line1} onChange={(e) => update(i, 'line1', e.target.value)} className={input} />
          <input type="text" placeholder="Street 2" value={a.line2} onChange={(e) => update(i, 'line2', e.target.value)} className={input} />
          <input type="text" placeholder="Street 3" value={a.line3} onChange={(e) => update(i, 'line3', e.target.value)} className={input} />
          <div className="grid grid-cols-4 gap-2">
            <input type="text" placeholder="City" value={a.city} onChange={(e) => update(i, 'city', e.target.value)} className={input} />
            <select value={a.state} onChange={(e) => update(i, 'state', e.target.value)} className={select}>
              <option value="">State/Province</option>
              {statesForCountry(a.country).map(s => <option key={s} value={s}>{STATE_LABELS[s] || s}</option>)}
            </select>
            <input type="text" placeholder="ZIP / Postal code" value={a.zip} onChange={(e) => update(i, 'zip', e.target.value)} className={input} />
            <select value={a.country} onChange={(e) => update(i, 'country', e.target.value)} className={select}>
              {COUNTRIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
        </div>
      ))}
      <button type="button" onClick={add} className="text-sm text-indigo-600 hover:text-indigo-800">+ Add address</button>
    </div>
  );
}
